module.exports = __webpack_public_path__ + "static/media/cart-icon.0626c2ce.svg";